import { combineReducers } from 'redux';

import {
  operationGroups,
  OperationGroupsState,
} from './operation-groups/operation-groups.reducer';
import {
  uploadOperations,
  UploadOperationsState,
} from './operation-groups/upload-operations/upload-operations.reducer';

export interface OperationPanelState {
  operationGroups: OperationGroupsState;
  uploadOperations: UploadOperationsState;
}

export const operationPanel = combineReducers({
  operationGroups,
  uploadOperations,
});
